import * as LD from 'launchdarkly-js-client-sdk';

export abstract class StaticUtilsService {
  public static LdClient: LD.LDClient;
}
